import React, { useState, useRef } from "react";
import { Container, Button, Text } from "./index.style";

const Footer = ({ onClick }) => {
  return (
    <Container>
      <Button onClick={onClick}>Mua ngay</Button>
      <Text>Đọc kỹ quy định hoàn tiền trước khi mua hàng nhé!</Text>
    </Container>
  );
};

export default Footer;
